export default ({
  pageState: { editorBlocks, editorIsBlockMoveView },
  data: { blockId }
}) => {
  if (!editorIsBlockMoveView)
    return {
      editorBlocks: {
        ...editorBlocks,
        [blockId]: {
          ...editorBlocks[blockId],
          isSelected: true
        }
      },
      editorIsBlockMoveView: true
    };

  let selectedBlocks = 0;
  for (let id of Object.keys(editorBlocks)) {
    if (editorBlocks[id].isSelected) selectedBlocks++;
  }

  if (!editorBlocks[blockId].isSelected)
    return {
      editorBlocks: {
        ...editorBlocks,
        [blockId]: {
          ...editorBlocks[blockId],
          isSelected: true
        }
      }
    };

  return {
    editorBlocks: {
      ...editorBlocks,
      [blockId]: {
        ...editorBlocks[blockId],
        isSelected: false
      }
    },
    editorIsBlockMoveView: selectedBlocks > 1 ? true : false
  };
};
